module.exports = __webpack_public_path__ + "img/fun-fact-thumb.4368ff93.png";